import {
  AddCreditCardMethodParameters,
  AddGiftCardMethodParameters,
  AddShippingMethodParameters,
  AddShoppingCartBulkParameters,
  AddShoppingCartParameters,
  CartItemDetailsParams,
  CheckoutParameters,
  DeleteShoppingCartParameters,
  PurchaseHistoryParams,
  RemoveCreditCardMethodParameters,
  RemoveGiftCardMethodParameters,
  ShopPromoParamsType,
  UpdateShoppingCartParameters
} from 'types';

import { get, post } from './axios';

const URLS = {
  getCartItemDetails: 'cart_get-item-details',
  cartCompleteCheckout: 'cart_complete-checkout',
  cartList: 'cart_list',
  shoppingCartAdd: 'cart_add',
  shoppingCartAddBulk: 'cart_add-bulk',
  shoppingCartUpdate: 'cart_update',
  shoppingCartDelete: 'cart_delete',
  shoppingCartAddPromo: 'cart_add-promo',
  shoppingCartShipping: 'cart_shipping',
  addShippingMethod: 'cart_add-shipping',
  addGiftCardPayment: 'cart_add-gift-card-payment',
  removeGiftCardPayment: 'cart_remove-payment',
  addCreditCardPayment: 'cart_add-payment',
  removeCreditCardPayment: 'cart_remove-payment',
  cartExecutePayment: 'cart_execute-payment',
  getClPurchaseHistory: 'cl-purchase-history-ext',
  getClPurchaseHistoryDetails: 'cl-purchase-history-details',
  verifyClCcardOttPrefs: 'verify-cl-ccard-ott-prefs',
  shoppingCartAddNotify: '/products/in-stock-notify-add',
  shoppingCartRemoveNotify: '/products/in-stock-notify-remove'
};

const cartApi = {
  getCartItemDetails: (params: CartItemDetailsParams) =>
    post(URLS.getCartItemDetails, { ...params }),
  cartCompleteCheckout: (params: CheckoutParameters) =>
    post(URLS.cartCompleteCheckout, { ...params }),
  getShoppingCartList: () => get(URLS.cartList),
  shoppingCartAdd: (params: AddShoppingCartParameters) =>
    post(URLS.shoppingCartAdd, { ...params }),
  shoppingCartAddNotify: (prid: number) =>
    post(URLS.shoppingCartAddNotify, { prid }),
  shoppingCartRemoveNotify: (prid: number) =>
    post(URLS.shoppingCartRemoveNotify, { prid }),
  shoppingCartAddBulk: (params: AddShoppingCartBulkParameters) =>
    post(URLS.shoppingCartAddBulk, { ...params }),
  shoppingCartUpdate: (params: UpdateShoppingCartParameters) =>
    post(URLS.shoppingCartUpdate, { ...params }),
  shoppingCartDeleteItem: (params: DeleteShoppingCartParameters) =>
    get(URLS.shoppingCartDelete, params),
  validateShopPromoCode: (params: ShopPromoParamsType) =>
    get(URLS.shoppingCartAddPromo, params),
  getShippingList: (invoice_id?: number) =>
    get(URLS.shoppingCartShipping, invoice_id ? { invoice_id } : {}),
  addShippingMethod: (params: AddShippingMethodParameters) =>
    get(URLS.addShippingMethod, params),
  addGiftCardPayment: (params: AddGiftCardMethodParameters) =>
    post(URLS.addGiftCardPayment, params),
  removeGiftCardPayment: (params: RemoveGiftCardMethodParameters) =>
    post(URLS.removeGiftCardPayment, params),
  addCreditCardPayment: (params: AddCreditCardMethodParameters) =>
    post(URLS.addCreditCardPayment, params),
  removeCreditCardPayment: (params: RemoveCreditCardMethodParameters) =>
    post(URLS.removeCreditCardPayment, params),
  cartExecutePayment: (invoice_id: number) =>
    post(URLS.cartExecutePayment, { invoice_id }),
  cartExecutePaymentWithOtt: (params: {
    cc_ott_token: string;
    invoice_id: number;
  }) => post(URLS.cartExecutePayment, params),
  getClPurchaseHistory: (params?: PurchaseHistoryParams) =>
    get(URLS.getClPurchaseHistory, params),
  getClPurchaseHistoryDetails: (checkoutId: number) =>
    get(URLS.getClPurchaseHistoryDetails, { checkout_id: checkoutId }),
  verifyClCcardOttPrefs: () => post(URLS.verifyClCcardOttPrefs)
};

export default cartApi;
